<div id="confirmCallback">
	<div class="container">
		<h1>
			<i class="fa-solid fa-check-circle"></i>
		</h1>
		<p>驗證成功</p>
		<br />
		<button (click)="navigateToSignIn()">
			<span>點擊進行登入</span>
		</button>
	</div>
</div>
